import { TranslateFn } from 'src/localization/translate'
import { Address } from 'src/queries/addresses/address.models'

/**
 * Renders the one-line billing address shown by this form.
 */
export const fullAddressTranslation = (
  address: Address,
  translate: TranslateFn,
): string =>
  translate(
    address.address2
      ? '${address1}, ${address2}, ${city}, ${province}, ${country}, ${postal}'
      : '${address1}, ${city}, ${province}, ${country}, ${postal}',
    {
      address1: address.address1,
      address2: address.address2 ?? '',
      city: address.city,
      country: address.country,
      province: address.province,
      postal: address.postal,
    },
  )
